import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComponentConfig, SelectorType, TaskSelector } from '../../shared/model';
import { LookupFieldService, OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { TaskStoreService } from './../task-store.service'; // Replace with the actual path
import { NbDialogService } from '@nebular/theme';
import { ViewContainersService } from '../../shared/services/view-containers.service';
import { LookUpDialogService } from '../../lookup-dialog-container/look-up-dialog.service';
import { UbsComponentStoreService } from '../../ubs-component-store.service';
import { LookupDialogContainerComponent } from '../../lookup-dialog-container/lookup-dialog-container.component';

@Component({
  selector: 'ubs-task-selector',
  templateUrl: './task-selector.component.html',
  styleUrls: ['./task-selector.component.scss']
})
export class TaskSelectorComponent implements OnInit, OnChanges{
  @Input() selector:TaskSelector;
  lookUpForm:OfbizForm;
  componentConfig:ComponentConfig;
  lookupSelectedValue:any;
  listForm:OfbizList
  listContainerTitle:string;
  parameters:any;
  addForm:OfbizForm;
  appContext:string;

  @Output() selectorParameters = new EventEmitter<any>();

  constructor(
      private taskStoreService:TaskStoreService,
      private componentStore:UbsComponentStoreService,
      private dialogService: NbDialogService,
      private lookUpDialogService:LookUpDialogService,
      private lookupFieldService:LookupFieldService) { 
        
      }
  
  ngOnInit(): void {
    this.componentStore.componentConfig$.subscribe(componentConfig => this.componentConfig = componentConfig)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["selector"]){
      console.log(this.selector)
      this.listForm = <OfbizList>this.selector.source;
      this.listContainerTitle = this.selector.title;
      if(this.selector.type === SelectorType.LOOKUP){
        this.lookUpForm = <OfbizForm>this.selector.source;
      }
    }
  }

  openDialogContainer(data):void{
    this.lookupSelectedValue = null;
      console.log({TrackDialog:{component:"AddContainerComponent",data:data}});
      //let componentConfig:ComponentConfig = this.state.componentConfig;
      this.dialogService.open(LookupDialogContainerComponent, {
        context:{
          componentConfig:this.componentConfig,
          data:data
        },
        dialogClass:'modal-full',
      }).onClose.subscribe(data => {
        console.log(data,this.lookUpForm.getFields());
        this.lookupSelectedValue = {data};
        this.lookupFieldService.setLookupSelectedValue(this.lookupSelectedValue)
        let lookedUpField = this.lookUpForm.getFields().find(field => field.name = data["field"]);
        if(lookedUpField){
          lookedUpField.value = data["value"];
          console.log(data,this.lookUpForm.getFields());
          //this.lookUpForm = Object.assign(Object.create(Object.getPrototypeOf(this.lookUpForm)), this.lookUpForm);

        }else{
          lookedUpField = this.lookUpForm.getFields()[0];
          lookedUpField.value = data["value"];
          console.log("Can't find lookedUpField",this.lookUpForm.getFields())
          this.lookUpForm = Object.assign(Object.create(Object.getPrototypeOf(this.lookUpForm)), this.lookUpForm);
        }
        
        
        //this.lookUpDialogService.lookupSelectedValue.subscribe(value => {console.log(value)})
      })
    }
    /**
     * Gets the parameters selected and transmit to parent.  Parameters will be used by siblings
     * @param e 
     */
    selectorFormData(e:any){
      this.selectorParameters.emit(e)
    }
    setSelectedRow(e){
      console.log({selectedRow:e});
      this.taskStoreService.updateSelectedRow(e)
    }
}
